import { render, staticRenderFns } from "./GangMember.vue?vue&type=template&id=2bc6fe92&scoped=true&"
import script from "./GangMember.vue?vue&type=script&lang=js&"
export * from "./GangMember.vue?vue&type=script&lang=js&"
import style0 from "./GangMember.vue?vue&type=style&index=0&id=2bc6fe92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc6fe92",
  null
  
)

export default component.exports